 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/title-page'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import DEDICATION from '@/components/dedication'
 import FOREWORD from '@/components/foreword'
 import THEYOUNGKING from '@/components/the-young-king'
 import THEBIRTHDAYOFTHEINFANTA from '@/components/the-birthday-of-the-infanta'
 import THEFISHERMANANDHISSOUL from '@/components/the-fisherman-and-his-soul'
 import THESTARCHILD from '@/components/the-star-child'
 import PUBLISHERSNOTE from '@/components/publishers-note'
 import LOVE_2 from '@/components/love_2'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import ABOUTTHEAUTHOR from '@/components/about-the-author'
 import ABOUTTHEEDITOR from '@/components/about-the-editor'
 import WORDFIRECLASSICS from '@/components/wordfire-classics'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/foreword",
 			"name" : "foreword",
 			"component" : FOREWORD
 		},
 		{
 			"path" : "/the-young-king",
 			"name" : "the-young-king",
 			"component" : THEYOUNGKING
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js